import { PropsWithChildren, ReactNode } from "react";

type Tone =
  | "neutral"
  | "brand"
  | "emerald"
  | "violet"
  | "amber"
  | "rose"
  | "ink";

interface BadgeProps extends PropsWithChildren {
  icon?: ReactNode;
  tone?: Tone;
  className?: string;
  dot?: boolean;
}

const tones: Record<Tone, string> = {
  neutral: "bg-ink-100 text-ink-700 ring-ink-200/50",
  brand: "bg-brand-50 text-brand-700 ring-brand-200/50",
  emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200/60",
  violet: "bg-violet-50 text-violet-700 ring-violet-200/60",
  amber: "bg-amber-50 text-amber-700 ring-amber-200/60",
  rose: "bg-rose-50 text-rose-700 ring-rose-200/60",
  ink: "bg-ink-900 text-white ring-ink-900/20",
};

const dotColors: Record<Tone, string> = {
  neutral: "bg-ink-500",
  brand: "bg-brand-500",
  emerald: "bg-emerald-500",
  violet: "bg-violet-500",
  amber: "bg-amber-500",
  rose: "bg-rose-500",
  ink: "bg-white",
};

const Badge = ({
  icon,
  tone = "neutral",
  className = "",
  dot,
  children,
}: BadgeProps) => (
  <span
    className={`inline-flex items-center gap-1 px-2 h-5 rounded-md text-[11px] font-medium ring-1 ${tones[tone]} ${className}`}
  >
    {dot && (
      <span className="relative flex h-1.5 w-1.5">
        <span
          className={`absolute inline-flex h-full w-full rounded-full ${dotColors[tone]} opacity-60 animate-ping`}
        />
        <span
          className={`relative inline-flex rounded-full h-1.5 w-1.5 ${dotColors[tone]}`}
        />
      </span>
    )}
    {icon}
    {children}
  </span>
);

export default Badge;
